"use strict";
/**
* TelemetryEvents.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* All the ECS client telemetry events
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryEventBase_1 = require("./TelemetryEventBase");
var EcsConfigFetchResponse = /** @class */ (function (_super) {
    __extends(EcsConfigFetchResponse, _super);
    function EcsConfigFetchResponse(_responseTime, _responseCode, _fetchAttempts, _hasValidToken, _serverEndpoint, _etag, _fetchDurationValid, _cacheAvailable, _responseSize, _configAge, _configExpired, _fetchStart, _fetchEnd) {
        var _this = _super.call(this) || this;
        _this._responseTime = _responseTime;
        _this._responseCode = _responseCode;
        _this._fetchAttempts = _fetchAttempts;
        _this._hasValidToken = _hasValidToken;
        _this._serverEndpoint = _serverEndpoint;
        _this._etag = _etag;
        _this._fetchDurationValid = _fetchDurationValid;
        _this._cacheAvailable = _cacheAvailable;
        _this._responseSize = _responseSize;
        _this._configAge = _configAge;
        _this._configExpired = _configExpired;
        _this._fetchStart = _fetchStart;
        _this._fetchEnd = _fetchEnd;
        return _this;
    }
    EcsConfigFetchResponse.prototype.getEventName = function () {
        return 'ecs_tsclient_fetch_config';
    };
    EcsConfigFetchResponse.prototype.getAttributes = function () {
        var attributes = _super.prototype.getAttributes.call(this);
        attributes['fetch_delay_ms'] = this._responseTime;
        attributes['fetch_response_code'] = this._responseCode;
        attributes['fetch_attempts'] = this._fetchAttempts;
        attributes['authenticated_user'] = this._hasValidToken;
        attributes['url'] = this._serverEndpoint;
        attributes['fetched_etag'] = this._etag;
        attributes['fetch_duration_valid'] = this._fetchDurationValid;
        attributes['cache_available'] = this._cacheAvailable;
        attributes['response_size'] = this._responseSize;
        attributes['config_age'] = this._configAge;
        attributes['config_expired'] = this._configExpired;
        attributes['fetch_start'] = this._fetchStart;
        attributes['fetch_end'] = this._fetchEnd;
        return attributes;
    };
    return EcsConfigFetchResponse;
}(TelemetryEventBase_1.TelemetryEventBase));
exports.EcsConfigFetchResponse = EcsConfigFetchResponse;
